module.exports = __webpack_public_path__ + "img/plan-expired-red.53091d74.svg";